module.exports = "/images/storage-concepts-flyer-thumb.png?31113c208df77fe935012e258bee917c";